import React, { createContext, useContext, useState, useEffect } from 'react';

const CityContext = createContext(null);

// Comprehensive list of major Indian cities
const CITIES = [
  'All India',
  // Metro Cities
  'Delhi',
  'Mumbai',
  'Bangalore',
  'Chennai',
  'Kolkata',
  'Hyderabad',
  // Tier 1 Cities
  'Pune',
  'Ahmedabad',
  'Jaipur',
  'Lucknow',
  'Kanpur',
  'Nagpur',
  'Indore',
  'Bhopal',
  'Patna',
  'Vadodara',
  'Surat',
  'Coimbatore',
  'Kochi',
  'Visakhapatnam',
  'Thiruvananthapuram',
  // NCR Region
  'Gurgaon',
  'Noida',
  'Faridabad',
  'Ghaziabad',
  'Greater Noida',
  // Popular Destinations
  'Goa',
  'Chandigarh',
  'Dehradun',
  'Shimla',
  'Manali',
  'Udaipur',
  'Jodhpur',
  'Agra',
  'Varanasi',
  'Amritsar',
  'Rishikesh',
  'Mysore',
  'Pondicherry',
  // East India
  'Jamshedpur',
  'Ranchi',
  'Bhubaneswar',
  'Guwahati',
  'Siliguri',
  'Rourkela',
  // West India
  'Nashik',
  'Aurangabad',
  'Rajkot',
  'Gandhinagar',
  // South India
  'Mangalore',
  'Madurai',
  'Tiruchirappalli',
  'Vijayawada',
  'Guntur',
  // North India
  'Jalandhar',
  'Ludhiana',
  'Patiala',
  'Meerut',
  'Agra',
  'Aligarh',
  'Moradabad',
  'Bareilly',
  'Gorakhpur',
  'Allahabad',
  // Central India
  'Raipur',
  'Jabalpur',
  'Gwalior',
  // Others option for custom city
  'Others'
];

export const CityProvider = ({ children }) => {
  const [selectedCity, setSelectedCity] = useState(() => {
    return localStorage.getItem('selectedCity') || 'All India';
  });
  
  // Store custom city if "Others" is selected
  const [customCity, setCustomCity] = useState(() => {
    return localStorage.getItem('customCity') || '';
  });

  useEffect(() => {
    localStorage.setItem('selectedCity', selectedCity);
  }, [selectedCity]);
  
  useEffect(() => {
    localStorage.setItem('customCity', customCity);
  }, [customCity]);

  // Get the effective city (custom city if "Others" is selected)
  const getEffectiveCity = () => {
    if (selectedCity === 'Others' && customCity) {
      return customCity;
    }
    return selectedCity;
  };

  return (
    <CityContext.Provider value={{ 
      selectedCity, 
      setSelectedCity, 
      cities: [...new Set(CITIES)],
      customCity,
      setCustomCity,
      getEffectiveCity
    }}>
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => {
  const context = useContext(CityContext);
  if (!context) {
    throw new Error('useCity must be used within a CityProvider');
  }
  return context;
};
